import '../../../rubberduck/dist/js/import-jquery-light.js';
import { LazyLoad } from '../../../rubberduck/dist/lib/rubberduck/LazyLoad.js';
import { backgroundSetter } from '../../../rubberduck/dist/lib/rubberduck/backgroundSetter/backgroundSetter.js';
import { EventCalendarHandler } from '../../../../app/src/rubberduck/event/src/Event/dist/js/EventCalendarHandler.js';
import { GDPRHandler } from '../../../../app/src/rubberduck/core/src/GDPR/dist/js/GDPRHandler.js';
import { QuackFormHandler } from '../../../../app/src/rubberduck/cms/src/Form/dist/QuackFormHandler.js';
import { PropertyHandler } from '../../../../app/src/rubberduck/property/dist/js/PropertyHandler.js';
import { Pagination } from '../../../rubberduck/dist/lib/rubberduck/pagination/pagination2.build.js';
import { getTranslation, viewport } from '../../../rubberduck/dist/js/utils.js';
import Swup from 'swup';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupGaPlugin from '@swup/ga-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';

require('is-in-viewport/lib/isInViewport.min.js');

var $html = $('html');
var $body = window.$body = $('body');
var $nav = $('.nav');
var $menu = $('.menu');
var $footer = $('.footer');
var $content = $('.content');

var bgSetter = null;
var ajax_lock = false;

var lang = $html.attr('lang');

var swup;
var $swup_status = $('.swup-status');

var $pagination;

var payment_form;

const lazyLoader = new LazyLoad();
lazyLoader.default();

let propertyHandler;

// SWUP
if (!isIE()) {
    if (swup == undefined) {
        let containers = ['#main', '#recaptcha_script', '.top__lang'];
        let swup_containers = []
        for (let i = 0; i < containers.length; i++) {
            const e = containers[i];
            if ($(e).length > 0) swup_containers.push(e);
        }
        var ga_measurement_id = null;
        if (google_credentials.analytics.measurement_id !== "") {
            ga_measurement_id = google_credentials.analytics.measurement_id;
        }
        var swup_plugins = [
            new SwupScriptsPlugin({
                head: false,
                body: true,
            }),
            new SwupHeadPlugin()
        ];
        if (google_credentials.analytics.active) {
            swup_plugins.push(
                new SwupGaPlugin({
                    gaMeasurementId: ga_measurement_id
                })
            );
        }
        if (google_credentials.tag_manager.active) {
            swup_plugins.push(new SwupGtmPlugin());
        }

        swup = new Swup({
            containers: swup_containers,
            cache: false,
            linkSelector: 'a[href^="' +
                window.location.origin +
                '"]:not([data-no-swup]):not([target="_blank"]):not([data-fancybox]):not(.no-swup)',
            animateHistoryBrowsing: true,
            skipPopStateHandling: function () {

                return false;

            },
            plugins: swup_plugins
        });

        // Swup events
        swup.hooks.on('animation:out:start', reset);
		swup.hooks.on('animation:out:end', destroy);
		swup.hooks.on('content:replace', onLoad);
        swup.hooks.on('link:self', function () {
            if (!$body.hasClass('menu--shown')) {
                scrollPage('#main');
            } else {
                toggleBurgerMenu();
            }
        });

        document.getElementById('google_credentials').remove();
    }
} else {
    $('.popup[data-popup="update-browser"]').fadeIn(1000);
    $html.removeClass('is-animating');
}
// Fade out content on page refresh
window.onbeforeunload = function (e) {
    if (
        typeof e.target.activeElement.href === 'undefined' ||
        e.target.activeElement.href.indexOf('tel:') == -1 &&
        e.target.activeElement.href.indexOf('mailto:') == -1
    ) {
        // Only when it is not a phone or mail link
        $html.addClass('is-animating');
        reset();
    }
}

function swupStatusChange(string) {
    $swup_status.fadeOut(125, function () {
        $swup_status.html(string).fadeIn(125);
    });
}

function onLoad() {

    // Google map on page reentry
    if (typeof initMap !== "undefined") initMaps();

    swupStatusChange(getTranslation('cms_general', 'page_loaded'));

    $content = $('#content');

    if (typeof backgroundSetter === "function") {
        bgSetter = new backgroundSetter();
        bgSetter.init();
    }

    $content = $('#content');

    if (typeof backgroundSetter === "function") {
        bgSetter = new backgroundSetter();
        bgSetter.init();
    }

    $('#main > .content .section:not(.fullBG):not(.fullBGfix)').each(function(index, section) {
        if ($(section).css('background-color') == $(section).next('.section:not(.fullBG):not(.fullBGfix)').css('background-color')) {
            $(section).next('.section:not(.fullBG):not(.fullBGfix)').find('> .padd').addClass('padd--bottom');
        }
    });
    if ($('#main > .content > .section:first-child:not(.fullBG):not(.fullBGfix)').css('background-color') == $('body').css('background-color')) {
        $('#main > .content > .section:first-child:not(.fullBG):not(.fullBGfix)').find('> .padd').addClass('padd--bottom');
    }

    // MENU AUTO ACTIVE STATE
    let currentURL = window.location.href;
    let $nav_links = $('a', $nav);
    let $menu_links = $('a', $menu);
    let $footer_links = $('a', $footer);
    let $all_links = $nav_links.add($menu_links).add($footer_links);

    // Nav and menu links
    for (let i = 0; i < $all_links.length; i++) {
        const $el = $all_links.eq(i).removeClass('active');
        if (currentURL == $el.attr('href')) {
            setTimeout(function () {
                $el.addClass('active');
            }, 10);
        }
    }
    // GDPR
    if (typeof GDPRHandler != 'undefined') {
        let gdpr = new GDPRHandler();
        gdpr.init();
    }

    $('.menu--desktop .lvl--1 > li, .menu--mobile .lvl--1 > li').children('ul').stop().slideUp(400);

    $body.on('mouseenter', '.menu--desktop .lvl--1 > li, .menu--mobile .lvl--1 > li', function () {
        $(this).children('ul').stop().slideDown(400);
    });
    $body.on('mouseleave', '.menu--desktop .lvl--1 > li, .menu--mobile .lvl--1 > li', function () {
        $(this).children('ul').stop().slideUp(400);
    });

    ///////////////////////////////////////////////////////////////////////////
    // DATEPICKER
    ///////////////////////////////////////////////////////////////////////////
    $('.form_datepicker').datepicker({
        beforeShow: function (input, inst) {
            inst.dpDiv.css({
                marginLeft: input.offsetWidth + 'px'
            });
            var classArr = $(input).closest('.section').attr('class').split(/\s+/);
            
            $.each(classArr, function(index, value){
                if (value.startsWith('RM')) inst.dpDiv.addClass(value + '-ui-datepicker');
            });
        }
    });

    // '####:'##::::'##:'##::::'##::'#######::'########::'####:'##:::::::'####:'########:'########::
    // . ##:: ###::'###: ###::'###:'##.... ##: ##.... ##:. ##:: ##:::::::. ##:: ##.....:: ##.... ##:
    // : ##:: ####'####: ####'####: ##:::: ##: ##:::: ##:: ##:: ##:::::::: ##:: ##::::::: ##:::: ##:
    // : ##:: ## ### ##: ## ### ##: ##:::: ##: ########::: ##:: ##:::::::: ##:: ######::: ########::
    // : ##:: ##. #: ##: ##. #: ##: ##:::: ##: ##.... ##:: ##:: ##:::::::: ##:: ##...:::: ##.. ##:::
    // : ##:: ##:.:: ##: ##:.:: ##: ##:::: ##: ##:::: ##:: ##:: ##:::::::: ##:: ##::::::: ##::. ##::
    // '####: ##:::: ##: ##:::: ##:. #######:: ########::'####: ########:'####: ########: ##:::. ##:
    // ....::..:::::..::..:::::..:::.......:::........:::....::........::....::........::..:::::..::
    ///////////////////////////////////////////////
    // PROPERTIES MAP
    ///////////////////////////////////////////////    
    if ($('.RMO14').length) {
        $('.RMO14__filters--display .displays').on('click', function () {
            $('.RMO14 .displays').removeClass('active');
            $(this).addClass('active');

            if ($('.grid-display').hasClass('active')) {
                $('.RMO14__map').css('display', 'none');
                $('.RMO14__grid').css('display', 'flex');
            } else {
                $('.RMO14__map').css('display', 'block');
                $('.RMO14__grid').css('display', 'none');
            }
        })
    }
    if ($('.RMF08').length) {
        $('.RMF08__specs-element').on('click', function () {
            $('.RMF08__specs-element.active').removeClass('active');
            $(this).addClass('active');
            let data_menu = $(this).data('menu');
            // show matching content
            $('.RMF08__content').each(function () {
                if ($(this).data('menu') == data_menu) {
                    $(this).slideDown();
                } else {
                    $(this).slideUp();
                }
            })
        })
        $('.RMF08__specs--menu select').on('change', function () {
            let value = $(this).val();
            $('.RMF08__content').each(function () {
                if ($(this).data('menu') == value) {
                    $(this).slideDown();
                } else {
                    $(this).slideUp();
                }
            })
        })
        // MENU CALCULATE BTN CLICK
        $('.RMF08_calculator-btn').on('click', function () {
            $('.RMF08_calculator').addClass('appear');
            $body.addClass('no-scroll');
        })
        $('.RMF08_calculator .close').on('click', function () {
            $('.RMF08_calculator').removeClass('appear');
            $body.removeClass('no-scroll');
        })
        // CALCULATOR RESULT
        $('#calc_mortgage_payment').on('click', function (e) {
            let $form = $(this).parents('form').first();
            let payment = propertyHandler.calcMortgage($form);
            let formatted_payment = payment + '$ / ' + $form.find('[name="payment_frequency"] option:selected').text();
            $('#insert_result_here').text(formatted_payment);
        });
        $('.RMF08_calculator .reset').on('click', function () {
            $('#insert_result_here').text($('.original_text').text())
        })
        ///////////////////////////////////////////////
        // TXX-CALCULATOR QUANTITY BUTTONS
        ///////////////////////////////////////////////
        $('.quantity .plus').on('click', function () {
            let input = $(this).closest('.quantity').siblings('input[type="number"]');
            let inputVal = input.val();
            var plus = '';

            if (isNaN(inputVal) || input.val() == "") {
                plus = 0 + 1;
            } else {
                plus = parseInt(inputVal) + 1;
            }
            input.val(plus);

        })
        $('.quantity .minus').on('click', function () {
            let input = $(this).closest('.quantity').siblings('input[type="number"]');
            let minus = parseInt(input.val()) - 1;
            if (minus >= 0) {
                input.val(minus);
            } else {
                input.val(0);
            }
        })
    }

    ///////////////////////////////////////////////////////////////////////////
    // RMO14 FILTERS
    ///////////////////////////////////////////////////////////////////////////
    $('.RMO14 .RMO14__filters--selection-select select').on('change', function () {
        $(this).siblings('.property_label').css('opacity', '1');
    })

    ///////////////////////////////////////////////////////////////////////////
    // SELECT2
    ///////////////////////////////////////////////////////////////////////////
    let select2_options = {
        debug: true,
        width: '100%',
        minimumResultsForSearch: Infinity, // Hide the search input
        theme: '',
        language: lang
    }
    $selects = $('select');

    for (let i = 0; i < $selects.length; i++) {
        let $el = $selects.eq(i);
        select2_options.dropdownParent = $el.parent();
        $el.select2(select2_options)
            .on('select2:open', function (e) {
                // Search
                $('.select2-search__field').attr('placeholder', (lang == 'fr' ? 'Recherche' : 'Search'));

                let $dropdown = $('.select2-dropdown');
                $dropdown.hide();
                setTimeout(function () {
                    $dropdown.slideDown(250);
                }, 10);
            });
    }

    // File inputs
    $file_inputs = $('.input--file input[type="file"]');
    $file_inputs.on('change', function () {
        let $this = $(this);
        let $display = $this.next();

        if ($this.val() != '') {
            $display.addClass('not-empty');
            $display.children('.input__path').clearQueue().stop().fadeOut(250);
            setTimeout(function () {
                $display.children('.input__path').html($this.val().replace('C:\\fakepath\\', '')).fadeIn(250);
            }, 250);
        } else {
            $display.removeClass('not-empty');
            $display.children('.input__path').clearQueue().stop().fadeOut(250);
            setTimeout(function () {
                $display.children('.input__path').html($this.attr('placeholder')).fadeIn(250);
            }, 250);
        }
    });
    $file_inputs.next().find('.input__clear').on('click', function () {
        $(this).closest('.form__input').find('input').val('').trigger('change');

        return false;
    });


    $body.on('click', '.redBox .close_wrapper', function () {
        $(this).closest('.redBox').slideUp(function () {
            $(this).remove();
        });
    });

    let form_handler = new QuackFormHandler({
        ajax_selector: 'form:not(.no_ajax):not(.custom_ajax):not(.filter_container)',
        no_ajax_selector: 'form.no_ajax'
    });

    ///////////////////////////////////////////////////////////////////////////
    // SLICK
    ///////////////////////////////////////////////////////////////////////////
    if ($('.slick--RGO07').length) {
        // Image glitch fix
        $('.slick--RGO07').on('init', function () {
            $slider = $(this);
            setTimeout(function () {
                $slider.slick('slickSetOption', 'infinite', true, true);
            }, 1000);
        }).each(function () {
            let RGO07_slides = $(this).children('.slide').length;
            let slides_to_show = 3;
            let slides_to_show_1200 = 2;
            if (RGO07_slides <= 3) {
                slides_to_show = RGO07_slides;
                slides_to_show_1200 = RGO07_slides;
                $(this).addClass('no-offset slides--' + slides_to_show);
            }

            $(this).slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 1000,
                fade: false,
                centerMode: false,
                autoplay: false,
                autoplaySpeed: 4000,
                slidesToShow: slides_to_show,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: false,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                // waitForAnimate: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: slides_to_show_1200,
                            infinite: true,
                            adaptiveHeight: false
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                            infinite: true,
                            adaptiveHeight: true
                        }
                    }
                ],
                rows: 0
            })
                .on('afterChange', function (e, slick, currentSlide) {
                    $(window).trigger('scroll');
                });
        });
    }
    
    if ($('.slick--RMO05').length) {
        $('.slick--RMO05').slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            // waitForAnimate: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1201,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
            rows: 0
        });
    }
    if ($('.slick--RMO13').length) {
        $('.slick--RMO13').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            // waitForAnimate: true,
            focusOnSelect: true,
            adaptiveHeight: true,
            rows: 0
        });
    }
    if ($('.slick--RMO10').length) {
        $('.slick--RMO10').slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            // waitForAnimate: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
            rows: 0
        });
    }
    if ($('.slick--RMO06').length) {
        $('.slick--RMO06').slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            // waitForAnimate: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1201,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ],
            rows: 0
        })
            .on('afterChange', function (e, slick, currentSlide) {
                $(window).trigger('scroll');
            });
    }
    if ($('.slick--RMO07, .slick--RMO03').length) {
        $('.slick--RMO07, .slick--RMO03').slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            // waitForAnimate: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
            rows: 0
        })
            .on('afterChange', function (e, slick, currentSlide) {
                $(window).trigger('scroll');
            });
    }
    if ($('.slick--RMO08').length) {
        $('.slick--RMO08').slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 2,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            // waitForAnimate: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            rows: 0
        })
            .on('afterChange', function (e, slick, currentSlide) {
                $(window).trigger('scroll');
            });
    }
    if ($('.slick--articles').length) {
        $('.slick--articles').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 2,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            rows: 0
        })
            .on('afterChange', function (e, slick, currentSlide) {
                $(window).trigger('scroll');
            });
    }
    if ($('.slick--RGO09').length) {
        let RGO09_slides = $('.slick--RGO09 .slide').length;
        let slides_to_show = RGO09_slides;
        if (RGO09_slides >= 3) {
            slides_to_show = 3;
            $('.slick--RGO09').addClass('slides--3');
        }

        $('.slick--RGO09').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: slides_to_show,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ],
            rows: 0
        })
            .on('afterChange', function (e, slick, currentSlide) {
                $(window).trigger('scroll');
            });
    }
    if ($('.slick--RMO19').length) {
        let $slides = $('.slick--RMO19 .slide:not(.slick-clone)');
        let slide_count = 4;
        if ($slides.length < 4) {
            slide_count = $slides.length;
        }
        $('.slick--RMO19').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: slide_count,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: (slide_count > 3 ? 3 : slide_count)
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: (slide_count > 2 ? 2 : slide_count)
                    }
                },
            ],
            rows: 0
        })
            .on('afterChange beforeChange', function (e, slick, currentSlide) {
                $(window).trigger('scroll');
            });
    }
    if ($('.slick--RGO21').length) {
        $('.slick--RGO21').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 1000,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: true,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            waitForAnimate: false,
            rows: 0
        })
            .on('afterChange beforeChange', function (e, slick, currentSlide) {
                $(window).trigger('scroll');
            });
    }

    ///////////////////////////////////////////////////////////////////////////
    // Give cards same height
    ///////////////////////////////////////////////////////////////////////////

    giveCardsSameHeight();

    ///////////////////////////////////////////////////////////////////////////
    // ICEBERG
    ///////////////////////////////////////////////////////////////////////////
    $body.on('click', '.iceberg__head a', function (e) {
        e.stopPropagation();
    });
    $body.on('click', '.iceberg__head', function (e) {
        let $this = $(this);
        // Slide toggle clicked iceberg
        $this.toggleClass('active')
            .next('.iceberg__body').stop().slideToggle(500);
    });
    $('.iceberg__head.active').next().show();

    function updatePagination(data) {
        if (data.additional_html) {
            if (data.additional_html.tags) {
                let html = '';
                html = data.additional_html.tags;
                if ($('#tags').length) {
                    $('#tags').html(html);
                    $('#tags .iceberg__head.active').next().show();
                }
            }
            if (data.additional_html.info_windows) {
                if (typeof propertyHandler != 'undefined') {
                    propertyHandler.setMapData(data.additional_html.info_windows);
                }
            }
        }
    }
    window['updatePagination'] = updatePagination;

    $body.on('change', '.filter_sub [type="checkbox"], .filter_sub [type="radio"]', function (e) {
        let filter = true;
        let container = $(this).closest('.filter_container');
        container.find('input:not(:checked)').parents('li').removeClass('active');
        // Filters default "View all"
        if ($(this).val() == '') {
            container.find('input').prop('checked', false);
            container.find('.active').removeClass('active');
            $(this).parents('li').addClass('active');
        } else {
            if ($(this).prop('checked')) {
                $(this).parents('li').addClass('active');
                if ($(this).hasClass('view_all')) {
                    $(this).closest('li').siblings().removeClass('active').find('input').prop('checked', false);
                } else {
                    $(this).closest('ul').find('input.view_all').prop('checked', false).closest('li').removeClass('active');
                }
            } else {
                $(this).parents('li').removeClass('active');
                if ($('[name="' + $(this).attr('name') + '"]:checked').length == 0) {
                    container.find('.filter_sub label').first().trigger('click');
                    filter = false;
                }
            }
        }
        if (filter) {
            filterPagination();
        }
    });

    $body.on('keypress', '.filter_sub [type="search"]', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            filterPagination();
        }
    });
    $body.on('click', '.filter_sub [type="search"] + button', function (e) {
        e.preventDefault();
        filterPagination();
    });
    $body.on('change', '.filter_sub select:not(.no_trigger)', function (e) {
        e.preventDefault();
        filterPagination();
    });

    $body.on('click', '.reset_filters', function (e) {
        e.preventDefault();
        let container = $(this).closest('.filter_container');
        // Uncheck all
        container.find('.filter_sub [type="checkbox"], .filter_sub [type="radio"]').prop('checked', false).parents('li.active').removeClass('active');
        container.find('.filter_sub select').addClass('no_trigger').val('').trigger('change').removeClass('no_trigger');
        container.find('.filter_sub [type="text"], .filter_sub [type="search"]').val('');
        // Check "View All"
        container.find('.filter-iceberg .filter_container > ul > .filter_sub:first-child').addClass('active');
        filterPagination();
    });

    ///////////////////////////////////////////////////////////////////////////
    // MIXITUP
    ///////////////////////////////////////////////////////////////////////////
    if ($('.mixitup').length) {
        if ($('.filtered:not(.pagination_content_wrapper)').length > 0) {
            var mixitup = require('mixitup');
            var mixitupMultifilter = require('../lib/mixitup/mixitup-multifilter.min.cjs');
            mixitup.use(mixitupMultifilter);
            var mixit = mixitup('.filtered:not(.pagination_content_wrapper)', {
                selectors: {
                    target: '.filtered_items',
                    control: '.mixitup li'
                },
                animation: {
                    queueLimit: 5
                },
                multifilter: {
                    enable: true
                },
                callbacks: {
                    onMixEnd: function(state) {
                        $(window).trigger('scroll');
                    },
                    onMixClick: function(state, originalEvent) {
                        $(state.container).closest('.section').find('.mixitup .filter_container .searchbar input').val('');
                    }
                }
            });
            const delay = (function(){
                var timer = 0;
                return function(callback, ms){
                    clearTimeout (timer);
                    timer = setTimeout(callback, ms);
                }
            })();
            var mixitupContainer, mixitupItems, mixitupSearchInputText;
            $body.on('input', '.mixitup.filters .filter_container .searchbar input', function() {
                mixitupSearchInputText = $(this).val().toLowerCase();
                mixitupContainer = $(this).closest('.section');
                mixitupItems = mixitupContainer.find('.filtered .filtered_items');
                // Delay function invoked to make sure user stopped typing
                delay(function(){
                    // Reset category to 'all'
                    let filter = mixitupContainer.find('.desktop_filters [data-filter].selected');
                    if (filter.length) {
                        filter.removeClass('selected');
                        filter.find('input').prop('checked', false);
                        mixitupContainer.find('.desktop_filters [data-filter="all"]').addClass('selected').find('input').prop('checked', true);
                    }
                    var matching = $();
                    // Check to see if input field is empty
                    if ((mixitupSearchInputText.length) > 0) {            
                        mixitupItems.each(function() {
                            // add item to be filtered out if input text matches items inside the title   
                            if ($(this).text().toLowerCase().match(mixitupSearchInputText)) {
                                matching = matching.add(this);
                            } else {
                                // removes any previously matched item
                                matching = matching.not(this);
                            }
                        });
                        mixit.filter(matching);
                    } else {
                        // resets the filter to show all item if input is empty
                        mixit.filter('all');
                    }
                }, 200);
            });
        }
        let prevent_change = false;
        // ON SELECT CHANGE
        $body.on('change', '.select_filters', function (e) {
            if (prevent_change === true) {
                prevent_change = false;
                return false;
            }
            let val = $(this).val();
            let $radios = $(this).closest('.filter_container').find('.desktop_filters li');
            $radios.each(function () {
                let $radio = $(this).find('input[type="radio"]').first();
                if ($radio.val() == val) {
                    $radio.closest('li')[0].click();
                }
            });
        });
    }

    $('.form-control').on('change', function () {
        $('.form-control option:selected').trigger('click');
    })


    // Filters sidebar
    $body.on('click', '.open-filters', function () {
        $body.addClass('filters--shown');
    });
    $body.on('click', '.close-filters', function () {
        $body.removeClass('filters--shown');
    });


    ///////////////////////////////////////////////////////////////////////////
    // CALENDRIER
    ///////////////////////////////////////////////////////////////////////////
    calendar_handler = new EventCalendarHandler();
    calendar_handler.init();

    // JQUERYUI DATEPICKER
    function setDatepicker(target) {
        let $datepicker = $(target);
        $datepicker.each(function () {
            let $this = $(this);
            $this.datepicker({
                showOtherMonths: true,
                selectOtherMonths: true,
                altField: "#datepicker",
                closeText: 'Fermer',
                // prevText: 'Précédent',
                // nextText: 'Suivant',
                currentText: 'Aujourd\'hui',
                // monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                // monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
                // dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                // dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
                // dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
                // weekHeader: 'Sem.',
                dateFormat: ($this.attr('data-format') ? $this.attr('data-format') : 'dd-mm-yy'),
            });

            if ($this.attr('data-min-date') != null) {
                let min_date = $this.attr('data-min-date');
                $this.datepicker('option', 'minDate', min_date);
            }

            if ($this.attr('data-max-date') != null) {
                let max_date = $this.attr('data-max-date');
                $this.datepicker('option', 'maxDate', max_date);
            }
        });
    }
    setDatepicker('.datepicker:not(.booking_picker)');

    // PROPERTY
    if (typeof PropertyHandler != 'undefined') {
        propertyHandler = new PropertyHandler();
    }

    ///////////////////////////////////////////////////////////////////////////
    // COPY URL
    ///////////////////////////////////////////////////////////////////////////
    $('.copy_url')
        .mousedown(function () {
            $(this).addClass('mouseDown');
        })
        .mouseup(function () {
            $(this).removeClass('mouseDown');
        });

    $body.on('click', '.copy_url', function () {
        var dummy = document.createElement('input'),
            text = window.location.href;

        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
        $('.link_copied').slideDown().delay(1000).slideUp();
    });

    ///////////////////////////////////////////////////////////////////////////
    // PAGINATION
    ///////////////////////////////////////////////////////////////////////////
    if ($('.pagination_wrapper').length > 0) {
        let number_per_page = 24;
        let current_page = 1;
        let params = window.location.search.substr(1).split('&');
        if (params.length > 0) {
            for (let i = 0; i < params.length; i++) {
                let pair = params[i].split('=');
                let key = pair[0];
                if (key == 'number_items') {
                    number_per_page = parseInt(pair[1]);
                }
                if (key == 'page') {
                    current_page = parseInt(pair[1]);
                }
            }
        }
        $pagination = new Pagination({
            display_go_to: false,
            size_list: 'mini',
            number_items_per_page: number_per_page,
            call_back_return: 'updatePagination'
        });

        $pagination.currentPage = current_page;

        filterPagination();
    }

    $(window).trigger('resize');
    $(window).trigger('scroll');




    /////////////////////// DAISY //////////////////////////////////


    // RMF19 - Display subscription btn
    if ($('.RMF19').length > 0) {

        $button = $('.RMF19__btn-container');

        if ($('.RMF36').length > 0) {
            $subBox = $('.RMF19').siblings('.RMF36').first();

            $subBox.prop('id', 'subscription_box');
        } else {
            $button.toggleClass('hide-btn');
        }

    }

    // Detection RGO01-B on top

    $RGO01_B = false;
    $content_first_child = $('.content').find(">:first-child");

    if ($content_first_child.hasClass("RGO01-B")) {
        $RGO01_B = true;
    } else {
        $RGO01_B = false;
    }

    if ($RGO01_B == true) {
        $body.addClass('has-page-header');
    } else if ($RGO01_B == false) {
        $body.removeClass('has-page-header');
    }



    // --- Get back to top
    $body.on('click', '.page-scroll', function () {
        var targetDiv = $(this).attr('href') || $(this).attr('data-target');
        // if (targetDiv) targetDiv = $(this).attr('data-target');

        scrollPage(targetDiv, $nav.height() + 100);

        return false;
    });

    // Scroll to anchor w/ padding-top
    $body.on('click', '.page-scroll-no-pad', function () {
        var targetDiv = $(this).attr('href') || $(this).attr('data-target');
        // if (targetDiv) targetDiv = $(this).attr('data-target');

        scrollPage(targetDiv, 50);

        return false;
    });

    // --- Ouverture/fermeture volets sitemap
    $('.caret-box').on('click', function () {

        let elmt = $(this).closest('div.RGF01__wrapper-item');
        let accordeon = elmt.children().last();

        let acc_scroll_height = accordeon.prop('scrollHeight');

        if (elmt.hasClass('accordeon-open')) {
            accordeon.css('height', 0);
        } else {
            accordeon.css('height', acc_scroll_height + 'px');
        }

        elmt.toggleClass('accordeon-open');
    });


    // --- Carousel RGO09
    let $sliders = $('.gallery_slider');

    // Add data for amount of slides in each slider
    for (let i = 0; i < $sliders.length; i++) {
        let $slider = $sliders.eq(i);
        let $slides = $slider.find('.gallery_slider__slide');

        $slider.attr('data-max-index', $slides.length - 1)
            .attr('data-index', 0);

        let slide_count = parseInt($slider.attr('data-max-index'));

        // First slide
        $slides.first().addClass('active');

        // Set classes 
        if (slide_count > 0) {
            // Next slides
            $slides.eq(1).addClass('next_slide');
            $slides.filter(':gt(1)').addClass('coming_right');

            // Set buttons
            $slider.find('.gallery_slider__nav--left').addClass('hide-button');
        } else {
            // Set buttons
            $slider.find('.gallery_slider__nav--left, .gallery_slider__nav--right').addClass('hide-button');
        }
    }

    // Click navigation
    $('.gallery_slider__nav--right').click(function () {
        swipeGallery('right', $(this).closest('.gallery_slider'));
    });
    $('.gallery_slider__nav--left').click(function () {
        swipeGallery('left', $(this).closest('.gallery_slider'));
    });
    $body.on('click', '.previous_slide', function () {
        swipeGallery('left', $(this).closest('.gallery_slider'));

        return false;
    });
    $body.on('click', '.next_slide', function () {
        swipeGallery('right', $(this).closest('.gallery_slider'));

        return false;
    });

    // Slider
    function swipeGallery(direction, $slider) {
        if (direction == 'right') {
            $slider.attr('data-index', parseInt($slider.attr('data-index')) + 1);
            if ($slider.attr('data-index') > $slider.attr('data-max-index')) {
                $slider.attr('data-index', $slider.attr('data-max-index'));
            }
        } else if (direction == 'left') {
            $slider.attr('data-index', parseInt($slider.attr('data-index')) - 1);
            if ($slider.attr('data-max-index') < 1) {
                $slider.attr('data-index', 0);
            }
        }

        classPickerGallery($slider);
        hideNavGallery($slider);
    }

    // Hide buttons if beginning/end of carousel
    function hideNavGallery($slider) {
        if ($slider.attr('data-index') < 1) {
            $slider.find('.gallery_slider__nav--left').addClass('hide-button');
        } else {
            $slider.find('.gallery_slider__nav--left').removeClass('hide-button');
        }

        if ($slider.attr('data-index') >= $slider.attr('data-max-index')) {
            $slider.find('.gallery_slider__nav--right').addClass('hide-button');
        } else {
            $slider.find('.gallery_slider__nav--right').removeClass('hide-button');
        }
    }

    // Change classes on nav click
    function classPickerGallery($slider) {
        let $slides = $slider.find('.gallery_slider__slide');
        clearClassGallery($slides);

        for (var i = 0; i <= $slider.attr('data-max-index'); i++) {
            let $slide = $slides.eq(i);
            let index = parseInt($slider.attr('data-index'));

            if (i < index - 1) {
                $slide.addClass('coming_left');
            } else if (i == index - 1) {
                $slide.addClass('previous_slide');
            }
            if (i == index) {
                $slide.addClass('active');
            } else if (i == index + 1) {
                $slide.addClass('next_slide');
            } else if (i > index + 1) {
                $slide.addClass('coming_right');
            }
        }
    }

    // Clear all slider classes
    function clearClassGallery(elmt) {
        elmt.removeClass('active');
        elmt.removeClass('coming_left');
        elmt.removeClass('previous_slide');
        elmt.removeClass('coming_right');
        elmt.removeClass('next_slide');
    }

    // --- Video controls

    $('.video__play').on('click', function() {
        let media = $(this).closest('div.video__controls').siblings('video');
        videoControl(media);
    });

    $('.video__volume').on('click', function() {
        let media = $(this).closest('div.video__controls').siblings('video');
        soundControl(media);
    });

    // RMO01
    $('.question_titre').on('click', function () {
        $question = $(this).closest('.question');

        $question.siblings().removeClass('opened')
            .find('.response_box').stop().slideUp(400);
        $question.toggleClass('opened').find('.response_box').stop().slideToggle(400);
    });

    $('.filter_choix').on('click', function (e) {
        e.preventDefault();
        $this = $(this);
        $categ = $(this).attr('data-id');
        $section = $this.closest('.section');

        $this.addClass('selected').siblings().removeClass('selected');

        $this.find('input').prop('checked', true).trigger('change');

        // Buggy slideToggles...
        if ($categ == 'all') {
            $section.find('.question').stop().slideDown(400, function () {
                $(this).height('').css('padding', '');
            });
        } else {
            $section.find('.question').stop().slideUp(400, function () {
                $(this).height('').css('padding', '');
            })
                .filter('[data-category="' + $categ + '"]').stop().slideDown(400, function () {
                    $(this).height('').css('padding', '');
                });
        }

        setTimeout(function () {
            $(window).trigger('resize').trigger('scroll');
        }, 10);
    });

    // RGO18
    $('.close-RGO18').click(function () {
        $(this).closest('.RGO18').fadeOut(500);

        setTimeout(() => {
            $(this).closest('.RGO18').remove();
        }, 500);
    })

    ////////////////////////////////// DAISY ///////////////////////////////

    // Close popup 
    $body.on('click', '.RGO16__close', closePopup);

    $(window).trigger('resize').trigger('scroll');

} // onLoad()

function videoControl(media) {
    if (media[0].paused == true) {
        media[0].play();
    } else {
        media[0].pause();
    }
    media.parent().find('.video__play .btn--on').toggleClass('video__btn--hidden', media[0].paused);
    media.parent().find('.video__play .btn--off').toggleClass('video__btn--hidden', !media[0].paused);
}

function soundControl(media) {
    media.parent().find().toggleClass('video__btn--hidden');
    media.prop('muted', !media.prop('muted'));
    media.parent().find('.video__volume .btn--on').toggleClass('video__btn--hidden', !media[0].muted);
    media.parent().find('.video__volume .btn--off').toggleClass('video__btn--hidden', media[0].muted);
}

function reset() {
    swupStatusChange(getTranslation('cms_general', 'loading_page'));
    // Remove event listeners
    $content.off();
    // Reset menu state
    $body.off().removeClass();
} // reset()
function destroy() {
    window.scrollTo(0, 0);
    // Destroy select2
    $('select').select2('destroy');
    // Destroy slicks
    $('.slick-initialized').slick('unslick');
} // destroy()

////////////////////////////////////////////////////////////////////////////////

function giveSizeToOthers($context, $toResize, minWidth, maxWidth) {
    if ($context.length > 0) {
        if ($toResize.length > 0) {
            if (!minWidth) var minWidth = 0; // compatibilité IE
            if (!maxWidth) var maxWidth = 9999; // compatibilité IE
            if (viewport().width > minWidth && viewport().width < maxWidth) {
                $context.each(function () {
                    var height = 0;
                    var $objects = $(this).find('.' + $toResize.attr("class").split(' ')[0]);

                    $objects.each(function () {
                        $objects.height('');
                        var currentHeight = $(this).children('.resize').outerHeight();

                        if (currentHeight > height) height = currentHeight;
                    });
                    $objects.children('.resize').parent().height(height);
                });
            } else {
                $toResize.height('');
            }
        } else if ($context.length > 0) {
            // console.log('"$toResize == undefined" dans giveSizeToOthers : '+$toResize.selector);
        }
    }
}

function giveSizeToOthersBis($context, $toResize, minWidth, maxWidth) {
    if ($context.length > 0) {
        if ($('.' + $toResize).length > 0) {
            if (!minWidth) var minWidth = 0; // compatibilité IE
            if (!maxWidth) var maxWidth = 9999; // compatibilité IE
            if (viewport().width > minWidth && viewport().width < maxWidth) {
                $context.each(function () {
                    var height = 0;
                    var $objects = $(this).find('.' + $toResize);

                    $objects.each(function () {
                        $objects.height('');
                        var currentHeight = $(this).outerHeight();

                        if (currentHeight > height) height = currentHeight;
                    });
                    $objects.outerHeight(height);
                });
            } else {
                $('.' + $toResize).height('');
            }
        }
    }
}

function handleResetFiltersVisiblity() {
    $('.reset_filters').each(function() {
        let hide = true;
        let btn = $(this);
        let inputs = btn.closest('form').find('input:not([type="hidden"]), select');
        inputs.each(function(index, input) {
            if (hide) hide = ($(input).val() == '');
            if (index == (inputs.length - 1)) btn.toggleClass('hide_reset', hide);
        });
    });
}
function filterPagination(callback) {
    callback = (typeof callback !== 'undefined' ? callback : null);
    if ($('.pagination_wrapper').length > 0) {
        if ($pagination.htmlWrapper.length > 0 && $pagination.htmlContentWrapper.length > 0) {
            $pagination.fetchAjaxInformationPagination(
                false,
                true,
                false,
                callback
            );
            handleResetFiltersVisiblity();
        }
    }
}

function giveCardsSameHeight() {
    giveSizeToOthersBis($('.RMO03'), 'service-title', 768);
    giveSizeToOthersBis($('.RMO03'), 'service-text', 768);
    giveSizeToOthersBis($('.RMO06'), 'member__name', 768);
    giveSizeToOthersBis($('.RMO06'), 'member__position', 768);
    giveSizeToOthersBis($('.RMO07'), 'card-title', 768);
    giveSizeToOthersBis($('.RMO07'), 'card-subtitle', 768);
    giveSizeToOthersBis($('.RMO07'), 'card-text', 768);
    // giveSizeToOthersBis($('.RMO14'), 'resize');
    // giveSizeToOthersBis($('.RMO10'), 'resize');
    // giveSizeToOthersBis($('.RMO09'), 'article-title', 768);
    // giveSizeToOthersBis($('.RMO09'), 'article-infos', 768);
    // giveSizeToOthersBis($('.RMO09'), 'article-text', 768);
}

function swapText($target, text) {
    $target.stop().fadeOut(250, function () {
        $(this).text(text);
    }).fadeIn(250);
}

/**
 * @author Maxime Doré
 * @param string targetDiv	le hash vers lequel scroller la page (ex : "#content")
 * @param number offset		le offsetTop soustrait au scrollTop (ex : 100 scroll 100px plus haut)
 */
function scrollPage(targetDiv, offset) {
    if (!offset) var offset = 0;

    if (!$body.hasClass('no-scroll') && $(targetDiv).length > 0) {
        window.scrollTo({ top: $(targetDiv).offset().top - offset, behavior: 'smooth' });
    }
}


// Detect IE
function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) { // If Internet Explorer, return version number
        return true;
    }

    return false;
}

function goBack() {
    window.history.go(-1);
}

// Resize Fn
function onResize() {
    giveSizeToOthers($('.row--0'), $('.resized'), 0);
    giveSizeToOthers($('.row--600'), $('.resized'), 600);
    giveSizeToOthers($('.row--768'), $('.resized'), 768);
    giveSizeToOthers($('.row--900'), $('.resized'), 900);
    giveSizeToOthers($('.row--1024'), $('.resized'), 1024);
    giveCardsSameHeight();
}
// Scroll Fn

// Scroll Fn
function onScroll(e, posTop) {
    if (!$html.hasClass('is-animating')) {
        if (!posTop) posTop = $(window).scrollTop();

        if (posTop > 100) {
            $body.addClass('scroll');
        } else {
            $body.removeClass('scroll');
        }
        // if (posTop > last_scroll_pos) {
        //     $body.addClass('going-down');
        // } else {
        //     $body.removeClass('going-down');
        // }
        // last_scroll_pos = posTop;

        // isInViewport
        $('.slick-initialized').each(function () {
            var $this = $(this);

            if ($this.is(':in-viewport()')) {
                if ($this.hasClass('slick-initialized') && $this.slick('slickGetOption', 'autoplay')) {
                    $this.slick('slickPlay');
                }
            } else if (!$this.hasClass('once')) {
                if ($this.hasClass('slick-initialized') && $this.slick('slickGetOption', 'autoplay')) {
                    $this.slick('slickPause');
                }
            }
        });
        $('.visible').each(function () {
            var $this = $(this);
            let media = $this.find('video[autoplay][muted]');
            if ($this.is(':in-viewport()')) {
                $this.addClass('alive');
                if (media.length) {
                    media[0].play();
                    videoControl(media);
                }
            } else if (!$this.hasClass('once')) {
                $this.removeClass('alive done');
                if (media.length) {
                    media[0].pause();
                    videoControl(media);
                }
            }
        });
    }
}
$(window).on('resize', $.throttle(100, onResize));
$(window).on('scroll', $.throttle(100, onScroll));
$(window).on('load', function () {
    // $(window).trigger('resize').trigger('scroll');

    $html.removeClass('is-animating');
    onLoad();
});
$(window).on('resetDOM', function () {
    if (typeof backgroundSetter === "function") {
        new backgroundSetter().init();
    }
    $(window).trigger('resize').trigger('scroll');
});






// Nouveau code //////////////////////////////////////////////////////////

// BURGER MENU
$('.hamburger').on('click', toggleBurgerMenu);

function toggleBurgerMenu() {
    $body.toggleClass('menu--shown');
    $body.removeClass('menu--scroll');
    // $menu.find('.active').removeClass('active');
    $menu.animate({
        scrollTop: 0
    });
    // Reset menu subs
    $('.menu__dropdown + ul', $menu).clearQueue().stop().slideUp(250);
}

// Scroll menu
$('.menu').scroll(function () {
    if ($(this).scrollTop() > 20) {
        $body.addClass('menu--scroll');
    } else {
        $body.removeClass('menu--scroll');
    }
});

// RGO16
function closePopup() {
    let $this = $(this);
    let $popup = $this.closest('.popup');

    $popup.fadeOut(500, function () {
        $(this).remove();
    });
}
